import { authState } from '@/utils/auth'
import { loadBusinessOptions, defaultBusinessOptions } from '@/utils/businessDictionaries'

export function nativePlateColorLabel(state, value) {
  const color = String(value == null ? '' : value)
  const active = state.plateColorOptions.find(item => item.value === color)
  if (active) return active.label
  const previous = state.nativePlateColorLabels[color] || (defaultBusinessOptions('vehicle_plate_color').find(item => String(item.value) === color) || {}).label
  return previous ? previous + (state.nativePlateColorsLoaded ? '（已停用）' : '') : '-'
}

export default {
  data() {
    return { plateColorOptions: [], nativePlateColorLabels: {}, nativePlateColorsLoaded: false, nativePlateColorsError: '', nativePlateColorSequence: 0, nativePlateColorsDestroyed: false, nativePlateInitialDefaultHandled: false }
  },
  computed: {
    nativePlateColorAccount() { return authState.user ? String(authState.user.id) : '' }
  },
  watch: {
    nativePlateColorAccount() {
      this.nativePlateColorSequence++
      this.plateColorOptions = []
      this.nativePlateColorLabels = {}
      this.nativePlateColorsLoaded = false
      this.nativePlateColorsError = ''
      this.nativePlateInitialDefaultHandled = false
      this.emitPlateColorState()
      if (typeof this.onPlateColorAccountChanged === 'function') this.onPlateColorAccountChanged()
      this.$emit('plate-color-account-change')
      if (this.nativePlateColorAccount) this.loadPlateColorOptions()
    }
  },
  created() { if (this.nativePlateColorAccount) this.loadPlateColorOptions() },
  beforeDestroy() { this.nativePlateColorsDestroyed = true; this.nativePlateColorSequence++ },
  methods: {
    async loadPlateColorOptions() {
      const sequence = ++this.nativePlateColorSequence
      const account = this.nativePlateColorAccount
      const isCurrent = () => !this.nativePlateColorsDestroyed && sequence === this.nativePlateColorSequence && account === this.nativePlateColorAccount
      this.plateColorOptions = []
      this.nativePlateColorsLoaded = false
      this.nativePlateColorsError = ''
      this.emitPlateColorState()
      try {
        const options = await loadBusinessOptions('vehicle_plate_color')
        if (!isCurrent()) return
        // 上游身份固定为字符串1/2/3，标签和选项顺序由现有业务字典决定。
        this.plateColorOptions = options.map(item => ({ ...item, value: String(item.value) }))
        this.nativePlateColorLabels = { ...this.nativePlateColorLabels, ...Object.fromEntries(this.plateColorOptions.map(item => [item.value, item.label])) }
        this.nativePlateColorsLoaded = true
        if (!this.nativePlateInitialDefaultHandled) {
          this.nativePlateInitialDefaultHandled = true
          const form = this.searchForm || this.form
          if (form) {
            const plate = this.searchForm ? form.licensePlate : form.vno
            const key = this.searchForm ? 'licensePlateColor' : 'vco'
            if (!plate && form[key] === '2' && !this.canSelectPlateColor('2')) form[key] = this.defaultPlateColor()
          } else if (!this.manualPlate && this.manualColor === '2' && !this.canSelectPlateColor('2')) this.manualColor = this.defaultPlateColor()
        }
        this.emitPlateColorState()
      } catch (error) {
        if (!isCurrent()) return
        this.nativePlateColorsError = error.msg || error.message || '车牌颜色字典加载失败'
        this.$message.error(this.nativePlateColorsError)
        this.emitPlateColorState()
      }
    },
    emitPlateColorState() { this.$emit('plate-color-options-change', { plateColorOptions: this.plateColorOptions, nativePlateColorLabels: this.nativePlateColorLabels, nativePlateColorsLoaded: this.nativePlateColorsLoaded }) },
    defaultPlateColor() { return this.canSelectPlateColor('2') ? '2' : (this.plateColorOptions[0] || {}).value || '' },
    canSelectPlateColor(value) { return this.nativePlateColorsLoaded && this.plateColorOptions.some(item => item.value === String(value)) },
    requirePlateColor(value) {
      if (this.canSelectPlateColor(value)) return true
      this.$message.warning(this.nativePlateColorsError || (this.nativePlateColorsLoaded ? '请选择正常启用的车牌颜色' : '车牌颜色字典正在加载，请稍后重试'))
      return false
    },
    plateColorLabel(value) { return nativePlateColorLabel(this, value) },
    onVehiclePlateFromListSelected(item) {
      if (!item || !this.requirePlateColor(item.vehiclePlateColor)) return
      const plate = item.value != null ? String(item.value).trim() : ''
      if (plate) this.searchForm.licensePlate = plate
      this.searchForm.licensePlateColor = String(item.vehiclePlateColor)
    }
  }
}
